/**
 * 幻灯片组件
 */
import React from 'react';
import { Row, Col, Carousel } from 'antd';
// import {winWidth} from '../../incs/FunHelper';

const imgStyle = { height: 630, width: '100%'};
const Slide = () => (
    <div>
        <Carousel autoplay dots={true}>
            <div>
                <div className='slide-bg1'>
                    <Row>
                        <Col offset={4} span={16}><img style={imgStyle} src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/slides/01HE4T1NVYR95NFSN84G07XZ93.png' alt='' /></Col>
                    </Row>
                </div>
            </div>
            <div>
                <div className='slide-bg2'>
                <Row><Col offset={4} span={16}><img style={imgStyle} src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/slides/01HE4T1QYJPSBME762WW9Q5RCV.png' alt='' /></Col></Row>
                </div>
            </div>
            <div>
                <div className='slide-bg3'>
                <Row><Col offset={4} span={16}><img style={imgStyle} src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/slides/01HE4T1RNGWSZ1T9MY83H98XBR.png' alt='' /></Col></Row>
                </div>
            </div>
            <div>
                <div className='slide-bg4'>
                <Row><Col offset={4} span={16}><img style={imgStyle} src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/slides/01HE4T1SCDB4MHVY7EZNY51XQE.png' alt='' /></Col></Row>
                </div>
            </div>
            <div>
                <div className='slide-bg5'>
                <Row><Col offset={4} span={16}><img style={imgStyle} src='https://xinzhiteng.oss-cn-shenzhen.aliyuncs.com/images/slides/01HE4T1Q8QW5FTP07P6BANRF43.png' alt='' /></Col></Row>
                </div>
            </div>
        </Carousel>
    </div>
);
export default Slide;